// Bar chart vertical — distribuições por dia, mês, hora.
import { BarChart as RBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { fmtNum } from "../../lib/format.ts";
import { chartTheme, tooltipStyle, defaultMargin } from "./theme.ts";

interface Props {
  data: Array<{ label: string; value: number; raw?: any }>;
  height?: number;
  formatValue?: (v: number) => string;
  color?: string;
  showAxis?: boolean;
}

export function BarChart({ data, height = 200, formatValue = fmtNum, color, showAxis = true }: Props) {
  if (!data.length) return <div className="center-loading">sem dados</div>;
  const t = chartTheme();
  const fillColor = color ?? t.primary;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RBarChart data={data} margin={defaultMargin}>
        {showAxis && <CartesianGrid stroke={t.grid} strokeDasharray="3 3" vertical={false} />}
        <XAxis
          dataKey="label"
          tick={{ fontSize: 10, fill: t.muted, fontFamily: "JetBrains Mono, monospace" }}
          axisLine={{ stroke: t.grid }}
          tickLine={false}
          interval="preserveStartEnd"
          minTickGap={20}
        />
        {showAxis && (
          <YAxis
            tickFormatter={formatValue}
            tick={{ fontSize: 10, fill: t.muted, fontFamily: "JetBrains Mono, monospace" }}
            axisLine={false}
            tickLine={false}
            width={48}
          />
        )}
        <Tooltip
          {...tooltipStyle}
          formatter={(v) => [formatValue(v as number), ""]}
          cursor={{ fill: t.grid, fillOpacity: 0.3 }}
        />
        <Bar dataKey="value" fill={fillColor} radius={[4, 4, 0, 0]} />
      </RBarChart>
    </ResponsiveContainer>
  );
}
